import React from "react";

/**
 * CORSA logo — uses the supplied PNG wordmark.
 */
export const CorsaWordmark = ({
  size = "md",
  className = "",
  dataTestId = "corsa-wordmark",
  alt = "CORSA",
}) => {
  const sizes = {
    sm: "h-7 md:h-8",
    md: "h-9 md:h-11",
    lg: "h-14 md:h-20",
    xl: "h-20 md:h-28",
  };
  return (
    <img
      src="/assets/logos/corsa-logo.png"
      alt={alt}
      data-testid={dataTestId}
      className={`${sizes[size] || sizes.md} w-auto select-none ${className}`}
      draggable="false"
    />
  );
};

export default CorsaWordmark;
